<template>
    <el-card>
        <div slot="header">
            <span>{{$t('ftype.'+type)}}</span>
        </div>
        <div class="el-col el-col-24 el-col-lg-16 el-col-xl-12">
            <el-form :model="form" ref="form" label-width="auto">
                <el-form-item :label="$t('app.order_no')">
                    <el-input :disabled="true" :value="order.order_no"></el-input>
                </el-form-item>
                <el-form-item prop="user_id" :label="$t('flow.user')" required>
                    <el-select :disabled="isOngoing" v-model="form.user_id">
                        <el-option v-for="item in user_list"
                                   :key="item.id"
                                   :label="item.nickname"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="cart_no" :label="$t('flow.cart_no')" v-if="type==1 || type==2" required>
                    <el-input :disabled="isOngoing" v-model="form.cart_no"></el-input>
                </el-form-item>
                <el-form-item prop="box_num" :label="$t('flow.box_num')" v-if="type==3 || type==4" required>
                    <el-input type="number" :disabled="isOngoing" v-model="form.box_num"></el-input>
                </el-form-item>
                <el-form-item :label="$t('app.start_time')" v-if="form.start_time">
                    <el-input :disabled="true" v-model="form.start_time"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" v-if="isOngoing" @click="onComplete">
                        {{$t('app.complete')}}{{$t('ftype.'+this.type)}}
                    </el-button>
                    <el-button type="primary" v-else @click="onSubmit">
                        {{$t('app.start')}}{{$t('ftype.'+this.type)}}
                    </el-button>
                    <el-button type="info" plain @click="goBack">{{$t('app.back')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-card>
</template>

<script>
    export default {
        name: "stock",
        props: {
            type: [String, Number],
            order_id: [String, Number],
        },
        computed: {
            isOngoing() {
                return this.form.id ? true : false;
            }
        },
        data() {
            return {
                form: {
                    order_id: this.order_id,
                    type: this.type,
                },
                user_list: [],
                order: {},
            };
        },
        created() {
            this.getInfo();
            let user_id = localStorage.getItem('sel_user_id');
            if (user_id) {
                this.form.user_id = +user_id;
            }
        },
        methods: {
            getInfo() {
                this.$api.get('default/info', {
                    order_id: this.order_id,
                    type: this.type
                }).then(res => {
                    this.user_list = res.data.users;
                    this.order = res.data.order;
                    if (res.data.node) {
                        this.form = res.data.node;
                    }
                });
            },
            goBack() {
                this.$router.back();
            },
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (!valid) {
                        return false;
                    }
                    this.$api.post('order/add', this.form).then(res => {
                        if (res.code == 0) {
                            localStorage.setItem('sel_user_id', this.form.user_id);
                            this.$message.success(res.msg);
                            this.form = res.data;
                        }
                    });
                });
            },
            onComplete() {
                this.$api.post('order/complete', this.form).then(res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        this.$router.back();
                    }
                });
            }
        },
    }
</script>

<style scoped>

</style>